<template>
  <!--
  - On envoie un mot et sa traduction, ainsi que n autres mots
  - Les différents mots anglais sont décomposés en syllabes
  - Le mot à traduire est proposé en français
  - L'utilisateur doit construire la traduction anglaise en la construisant à partir de syllabes
  -->
  <div style="height: 100%">
    <div id="cardQ">
      <div id="question">
        {{ word.french }}
      </div>

      <syllables-answer
          :syllables="syllablesList"
          :goodAnswer="goodAnswer"
          :answerTrad="answerTrad"
          :sameLanguage="sameLanguage"
          :pass="pass"
          @goodAnswer="giveAnswer">
      </syllables-answer>

      <div class="bigRoundAngles bigPaddingRound flexwrap centercenter clickable red"
           @click="giveAnswer(false); pass = true">
        <span>Je passe</span> <i class="fas fa-arrow-right" style="margin-left: 2vw"></i>
      </div>
    </div>

  </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: "vocabularySyllables",

  components: {
    syllablesAnswer: () => import(/* webpackPrefetch: true */ '@/components/syllablesAnswer.vue')
  },

  props: {
    // Un mot (anglais et français) et une liste de n mots anglais comprenant le mot à trouver
    word: Object,
    otherWords: Array,
    answerLanguage: String,
  },

  created() {
    if(this.answerLanguage === 'fr') {
      this.goodAnswer = this.word.french;
      this.answerTrad = this.word.english;
      this.sameLanguage = true;
    }
    else {
      this.goodAnswer = this.word.english;
      this.answerTrad = this.word.french;
    }
    this.createSyllablesList()
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
    pass: {
      get() {
        return this.passNext
      },
      set(value) {
        this.passNext = value
      }
    }
  },

  methods: {
    giveAnswer(isCorrect) {
      let timeout = 800;
      if(!isCorrect) {
        timeout = 2000;
      }
        window.setTimeout(() => (this.$emit('answer', isCorrect)), timeout)
    },

    createSyllablesList: function() {
      this.syllablesList = this.syllabify(this.otherWords)
    },

    syllabify: function(words) {
      const syllableRegex = /[^aeiouy]*[aeiouy]+(?:[^aeiouy]*$|[^aeiouy](?=[^aeiouy]))?/gi;
      let syllablesTab = []
      words.forEach(element => {
        element.split(' ').forEach(word => {
          syllablesTab = syllablesTab.concat(word.match(syllableRegex))
        })
      })
      /*for(let element of words) {
        syllablesTab = syllablesTab.concat(element.match(syllableRegex))
      }*/

      this.shuffleArray(syllablesTab);

      let syllablesList = []
      syllablesTab.forEach(function(element, index) {
        syllablesList.push({
          value: element,
          id: index,
          list: 'prop',
          order: 0
        })
      })
      return syllablesList;
    },

    shuffleArray: function(tab) {
      for (var i = tab.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = tab[i];
        tab[i] = tab[j];
        tab[j] = temp;
      }
    },
  },

  data: function() {
    return {
      syllablesList: [],
      count: 0,
      goodAnswer: '',
      answerTrad: '',
      sameLanguage: false,
      passNext: false
    }
  }
}
</script>

<style scoped>

#cardQ {
  position: relative;
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  justify-content: center;
  justify-items: center;
  align-items: center;
  width: 100%;
  height: calc(100% - 7vw);
  padding: 3.5vw;
  background-color: var(--color2);
}

#question {
  align-self: flex-end;
  font-size: 300%;
  font-weight: bold;
  text-align: center;
}

@media screen and (max-device-width: 767px) {
  #cardQ {
    height: calc(100% - 20vw);
    padding: 8vw 5vw 8vw 5vw;
  }
}
</style>